import React, { Fragment, useState, useEffect } from "react";
import io from "socket.io-client";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { getProfileById } from "../../actions/profile";
import { jobChatMessage, deleteChatMessage } from "../../actions/stream";

import StreamChatBlue from "../layout/Employers/StreamChatBlue";
import EmployerStreamVideo from "../layout/Employers/EmployerStreamVideo";
import UsersInChat from "../layout/Employers/UsersInChat";
import LoggedInNavBlue from "../layout/IME/LoggedInNavBlue";
import StreamSecondaryLogo from "../layout/IME/StreamSecondaryLogo";

let socket;

const EmployerLiveStream = ({
  match,
  auth: { user, channelid, jobtitle, location, verified },
  getProfileById,
  jobChatMessage,
  deleteChatMessage,
  profile: { profile },
  isAuthenticated,
}) => {
  const ENDPOINT = "localhost:5000";

  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [room, setRoom] = useState(match.params.channelid);
  const [imeBotAvi, setimebotavi] = useState("Innovate_Me_logo_blue.png");
  const [showChat, setShowChat] = useState(true);

  const maxLength = 100;

  const deleteMessage = (id, message) => {
    deleteChatMessage(match.params.channelid, message);
    const removeIndex = messages
      .map((deletedMessage) => deletedMessage.messageid)
      .indexOf(id);

    messages.splice(removeIndex, 1);

    setMessages([...messages]);
  };

  useEffect(() => {
    getProfileById(match.params.channelid);
  }, [getProfileById, match.params.channelid]);

  useEffect(() => {
    setRoom(match.params.channelid);
  }, [match.params.channelid, room]);

  useEffect(() => {
    if (user) {
      socket = io(ENDPOINT);

      socket.on("roomUsers", (room, users) => {
        console.log(room, users);
      });

      socket.emit("joinRoom", {
        imebotavi: imeBotAvi,
        channelid: user.channelid,
        avatar: user.avatar,
        firstname: user.firstname,
        lastname: user.lastname,
        room: match.params.channelid,
      });
    }

    return () => {
      if (socket) {
        socket.emit("leave");

        socket.on("roomUsers", (users) => {
          // setViewerCount([...users.users]);
        });

        socket.disconnect();

        socket.off();
      }
    };
  }, [ENDPOINT, match.params.channelid, user]);

  useEffect(() => {
    socket.on("message", (message) => {
      setMessages([...messages, message]);
    });
  }, [messages]);

  const sendMessage = (e) => {
    e.preventDefault();
    if (message) {
      jobChatMessage(match.params.channelid, message);
      socket.emit(
        "chatMessage",
        message,
        user.firstname,
        user.lastname,
        user.avatar,
        room
      );
      setMessage("");
    }
  };

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <LoggedInNavBlue />
      <section className={showChat ? "flex-only-alt" : "flex-no-chat"}>
        <UsersInChat />
        <div className="main-stream-content">
          <div className="video-chat">
            <EmployerStreamVideo showChat={showChat} />
            {!showChat && (
              <div className="showchaticon" onClick={() => setShowChat(true)}>
                <i className="far fa-comment fa-2x blue"></i>
              </div>
            )}
          </div>
          <div className="notif-user-container">
            <div className="notification-user">
              <p className="notif-name blue">New Follower</p>
              <div className="avi-container">
                <div className="notif-avi"></div>
              </div>
              <p className="notif-user-name">User Name</p>
            </div>
          </div>
          <div className="stream-information-container">
            <div className="stream-info-grid">
              <div className="stream-grid-container">
                <div className="stream-info">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${profile.avatar}`}
                    className="streamer-user-avi"
                    alt="avatar"
                  />
                  <div className="helper-container">
                    <p className="stream-description">
                      Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                      Nam ratione aut eaque dolor ea temporibus laboriosam
                      laborum recusandae odio omnis.
                    </p>
                    {/* <div className="stream-keywords">
                      <ul>
                        {live_discussion.keywords.length > 0 &&
                          live_discussion.keywords.map((keyword) => {
                            return (
                              <li
                                className="stream-text-keywords blue"
                                key={keyword._id}
                              >
                                {keyword.text}
                              </li>
                            );
                          })}
                      </ul>
                    </div> */}
                    <div className="stream-lower-info">
                      <ul className="creator-stream-items">
                        <li class="stream-item blue bold">
                          {profile.companyname}
                        </li>
                        <li class="stream-item blue bold">
                          {profile.channelid}
                        </li>
                        <li className="stream-item">
                          {profile.firstname} {profile.lastname}
                        </li>
                        <li className="stream-item">
                          {profile.location && profile.location.city},{" "}
                          {profile.location && profile.location.state}
                        </li>
                        <li className="stream-item">
                          <i className="far fa-clock mr-5 blue"></i>
                          Date
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="stream-grid-container">
                <StreamSecondaryLogo />
              </div>
            </div>
          </div>
          <div className="stream-live-container">
            <div className="input-label-container">
              <label
                for="streamdescription"
                className="container-label bold blue"
              >
                Stream Description:
              </label>
              <div className="container-hidden-input">
                <input
                  className="round-input-alt"
                  placeholder="Update Stream Description"
                  type="text"
                  name="streamkey"
                />
                <button className="round-button-alt background-blue">
                  <i className="far fa-paper-plane"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="margin-top"></div>
        </div>
        {showChat && (
          <StreamChatBlue
            messages={messages}
            message={message}
            setMessage={setMessage}
            sendMessage={sendMessage}
            deleteMessage={deleteMessage}
            setShowChat={setShowChat}
            maxLength={maxLength}
          />
        )}
      </section>
    </Fragment>
  );
};

EmployerLiveStream.propTypes = {
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  getProfileById: PropTypes.func.isRequired,
  jobChatMessage: PropTypes.func.isRequired,
  deleteChatMessage: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  profile: state.profile,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {
  getProfileById,
  jobChatMessage,
  deleteChatMessage,
})(EmployerLiveStream);
